// SCRIPT 7 START by Jacob @ 02.12.21 9AM JAPAN Time
// First variants color are always selected and its featured image and link are updated.
// This fixes the homepage, product pages (Recommended section), and collection pages.
$(window).bind( 'load ajaxComplete', function() {
  	// Check if current page is either home, product, or collection.
	if ( jQuery("body").hasClass("pagecollection") || 
		jQuery("body").hasClass("pageindex") || 
		jQuery("body").hasClass("pageproduct") ) {
		var variantPerProduct = jQuery('.tt-options-swatch.productitem-option1-js');
		if ( variantPerProduct === undefined ) { return; }
		variantPerProduct.each(function(i){
			var arrManCollect = [];
			var arrManFalse = [];
			var thisColorsCollectParent = jQuery(this);
			var thisColorCollect = thisColorsCollectParent.children("li");
			if ( thisColorCollect === undefined ) { return; }
			thisColorCollect.each(function(){
				var thisColorCollect = jQuery(this).attr("data-tag");
				if ( thisColorCollect === undefined ) { return; }
				var thisColorAvailability = jQuery(this).attr("data-availability");
				if ( thisColorAvailability === undefined ) { return; }
				if ( thisColorAvailability == 'true' ) {
					arrManCollect.push(thisColorCollect);
				}
				if ( thisColorAvailability == 'false' ) {
					arrManFalse.push(thisColorCollect);
				}
			});
			arrManCollect.sort();
			arrManFalse.sort();
			if ( arrManCollect === undefined ) { return; }
			if ( arrManFalse === undefined ) { return; }
			var arrManMaster = arrManCollect.concat(arrManFalse);
			thisColorCollect.each(function(i){
				if (i==0) {
					thisColorsCollectParent.children('li[data-tag="'+arrManMaster[i]+'"]')
						.attr("data-flexorder",i).css({"order":i});
					thisColorsCollectParent.find('li[data-tag="'+arrManMaster[i]+'"] a')
						.trigger("click");
					var colorChanger = thisColorsCollectParent.find('li[data-tag="'+arrManMaster[i]+'"]');
					if ( colorChanger === undefined ) { return; }
					var colorChangerSrc = colorChanger.attr("data-img");
					var colorChangerVarId = colorChanger.attr("data-var_id");
					var colorChangerTag = colorChanger.attr("data-tag");
					if ( colorChangerSrc === undefined ) { return; }
                  
                  	if ( colorChangerSrc != '' ) {
                        if ( colorChangerVarId === undefined ) { return; }
                        if ( colorChangerTag === undefined ) { return; }
                        var colorChangee = thisColorsCollectParent
                            .parent().parent().parent().parent().find('a[class^="productItemUrl"]');
                        if ( colorChangee === undefined ) { return; }
                        var colorChangeeHref = colorChangee.attr("href");
                        if ( colorChangeeHref === undefined ) { return; }
                      
                      	colorChangee.find("img").attr("srcset",colorChangerSrc);
                      	colorChangee.find('img').attr("data-mainimage",colorChangerSrc);
                        colorChangee.find("img").attr("data-srcset",colorChangerSrc);
                        
                        if (colorChangeeHref.indexOf("?") >= 0) {
                          var colorChangeeHrefURL = colorChangeeHref.split("?")[0];
                          colorChangee.attr("href",colorChangeeHrefURL+'?variant='+colorChangerVarId); 
                        } else {
                          colorChangee.attr("href",colorChangeeHref+'?variant='+colorChangerVarId); 
                        }
                    }
                  
				} else {
					thisColorsCollectParent.children('li[data-tag="'+arrManMaster[i]+'"]')
						.attr("data-flexorder",i).css({"order":i});
				}
			});
		});
	}
});
$(window).on( 'load', function() {

    if ( jQuery("body").hasClass("pageindex") ) {

        // Children.
        var variantPerProduct = jQuery('.respimgsize.tt-product.product-parent');
        if ( variantPerProduct === undefined ) { return; }

        variantPerProduct.each(function(){
            
            var variantPerProductThis = jQuery(this);
            var variantPerProductActive = variantPerProductThis.find(".tt-description .tt-options-swatch.productitem-option1-js li.active");
            if ( variantPerProductActive === undefined ) { return; }
            var variantPerProductActiveSrc = variantPerProductActive.attr("data-img");
            var variantPerProductActiveVarId = variantPerProductActive.attr("data-var_id");
            if ( variantPerProductActiveSrc === undefined ) { return; }
            if ( variantPerProductActiveVarId === undefined ) { return; }

            // Parent.
            var variantPerProductParent = variantPerProductActive.parent().parent().parent().parent().parent();
            if ( variantPerProductParent === undefined ) { return; }
            var variantPerProductLink = variantPerProductParent.find('.tt-image-box a[class^="productItemUrl"]');
            if ( variantPerProductLink === undefined ) { return; }
            var variantPerProductLinkURL = variantPerProductLink.attr("href");
            if ( variantPerProductLinkURL === undefined ) { return; }
            
            // Start Applying Change.
          	variantPerProductLink.find('a[class^="productItemUrl"] img').attr("srcset",variantPerProductActiveSrc);
          	variantPerProductLink.find('a[class^="productItemUrl"] img').attr("data-mainimage",variantPerProductActiveSrc);
            variantPerProductLink.find('a[class^="productItemUrl"] img').attr("data-srcset",variantPerProductActiveSrc);
          
            if (variantPerProductLinkURL.indexOf("?") >= 0) {
                var variantPerProductLinkURLNew = variantPerProductLinkURL.split("?")[0];
                variantPerProductLink.attr("href",variantPerProductLinkURLNew+"?variant="+variantPerProductActiveVarId);
            } else {
                variantPerProductLink.attr("href",variantPerProductLinkURL+"?variant="+variantPerProductActiveVarId);
            }

        });
        
    }

});
// SCRIPT 7 END.